import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from '@lib/components/ErrorBoundary/ErrorBoundary';
import Logo from '@lib/components/Logo/Logo';
import AccountLockedLayout from '@lib/layouts/AccountLockedLayout/AccountLockedLayout';
import ForgotPasswordLayout from '@lib/layouts/ForgotPasswordLayout/ForgotPasswordLayout';
import styles from './AuthLayout.module.scss';

interface Props {
  accountLockedUrl?: string;
  accountSecuredComponent?: React.ReactElement;
  accountSecuredUrl?: string;
  finishRegistrationUrl: string;
  forgotPasswordUrl: string;
  lockAccountComponent?: React.ReactElement;
  lockAccountUrl?: string;
  loginUrl: string;
  logoUrl: string;
}

function AuthLayout(props: Props): React.ReactElement {
  const {
    accountLockedUrl,
    accountSecuredComponent,
    accountSecuredUrl,
    lockAccountComponent,
    lockAccountUrl,
    logoUrl,
    loginUrl,
    forgotPasswordUrl,
    finishRegistrationUrl,
  } = props;
  const location = useLocation();
  const { pathname } = location;
  if (pathname === forgotPasswordUrl) {
    return <ForgotPasswordLayout loginUrl={loginUrl} />;
  }

  if (accountLockedUrl && pathname === accountLockedUrl) {
    return <AccountLockedLayout loginUrl={loginUrl} />;
  }

  if (
    accountSecuredUrl &&
    pathname === accountSecuredUrl &&
    accountSecuredComponent
  ) {
    return accountSecuredComponent;
  }

  if (lockAccountUrl && pathname === lockAccountUrl && lockAccountComponent) {
    return lockAccountComponent;
  }

  const getOutlet = () => (
    <ErrorBoundary location={location}>
      <Outlet />
    </ErrorBoundary>
  );

  if (pathname === finishRegistrationUrl) {
    return getOutlet();
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <NavLink to={logoUrl}>
          <Logo />
        </NavLink>
      </div>
      <div className={styles.body}>
        <div className={styles.wrap}>{getOutlet()}</div>
      </div>
    </div>
  );
}

export default AuthLayout;
